import { ErrorRobotGraphic } from "../../components/graphics/error-robot";
import { IBwjBillboardProps } from "../../framework/components/bwj-billboard";
import { BwjButtonType } from "../../framework/components/bwj-button";
import { xlate, xlationContext } from "../../framework/utils/i18n";

xlationContext('Standard major error view');

export const useStandardErrorState = () => {

  const props: IBwjBillboardProps = {
    graphic: ErrorRobotGraphic,
    graphicPortraitOriented: true,
    message: xlate('Whoopsie... An unexpected error occurred.  Try reloading the app'),
    buttons: [{
      buttonStyle: BwjButtonType.PrimaryStandard,
      text: xlate('Reload application'),
      onClick: () => window.location.reload(),
    }],
  };

  return props;
}